//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  created () {
    // console.log(this.classList)
  },
  props: {
    // 要跳转的前缀
    routePrev: {
      type: String,
      default: '/collection/' // 表示是collection
    },
    classList: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: '作者'
    }
  },
  methods: {
    handleClick (item, title) {
      // this.$emit('click-item', item, title)
    }
  }
}  



// WEBPACK FOOTER //
// ./src/components/nav_common/CommonClassifier.vue